<template>
  <footer>
    <v-container fluid class="primary">
      <v-container>
        <v-row>
          <v-col cols="12" sm="4" md="3">
            <v-img :src="require(`../assets/${logo}`)" width="160px" />
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <p class="font-weight-light white--text">
              {{ $t('operator') }}:
            </p>
            <p class="ml-4 white--text">TMX Mobile Solution Szerviz Kft<br>{{ $t('address') }}: 2040 Budaörs Kinizsi u. 2/b</p>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: 'storeFooter',
  props: {
    logo: String,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
